import React, { useState, useEffect, memo, useRef, useMemo } from 'react'
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../reducers/form';
import { fetchDispath } from '../../functions/fetch'
import { updWorkGant, addArrowWorkToGant } from '../../api/form-gant.api'
import { addGantArrow } from '../../reducers/gant'
import { typeGant } from '../../enum/gant.enum'
import moment from 'moment'
import 'moment/locale/ru';
import { COLUMNS_ARR, COLUMNS_OBJ, formViewProps, formName } from './gant.const'

import GridGantt from './content/GridGantt';
import DefsPattern from './content/DefsPattern';
import GridTable from './content/GridTable';
import Arrows from './content/Arrows'
import DateLine from './content/DateLine'
import TableData from './content/TableData'
import PropsView from './content/PropsView'
import { Box } from '@mui/material';
import { addDays, diffDays, enrichTaskWithMoments, formDateSelector, getGanttDateRange, getMinMaxDates, todayString } from './utils/dateHelpers';
import { createSelector } from 'reselect';
import { svgProps } from './utils/svgConfig'

const moveTypes = {
  progress: 'progress',
  date: 'date',
  dateParent: 'date_parent',
  dateMilestone: 'date_milestone',
  endDate: 'endDate',
  startDate: 'startDate',
  arrowStart: 'arrowStart',
  arrowEnd: 'arrowEnd'
}
const listenerTable = (evt) => {
  const container = evt.target;
  const scrollX = container.scrollLeft;
  const x = screenXtoSVGUnits(scrollX)
  document?.getElementById("sticky-work")?.setAttributeNS(null, "transform", `translate(${x},0)`)
}
function screenYtoSVGUnits(val) {
  const svg = document.getElementById("svg-full");
  let pt = svg.createSVGPoint();
  pt.x = 0;
  pt.y = val;
  pt = pt.matrixTransform(svg.getCTM().inverse());
  return pt.y;
}
function screenXtoSVGUnits(val) {
  const svg = document.getElementById("svg-full");
  let pt = svg.createSVGPoint();
  pt.x = val;
  pt.y = 0;
  pt = pt.matrixTransform(svg.getCTM().inverse());
  return pt.x;
}
function formSelector(formName, field) {
  return state => state.form?.[formName]?.values[field]
}
function formSelectorLength(formName, field) {
  return state => state.form?.[formName]?.values[field].length
}
const viewBoxWidth = 1000;
const viewBoxHeight = 400;

const useStylesViewBlock = makeStyles(theme => ({
  triangle: {
    cursor: 'ew-resize',
    visibility: 'hidden',
    fill: "#ddd"
  },
  arrow_circle: {
    cursor: 'pointer',
    visibility: 'hidden',
    fill: "#ddd",
    '&:hover': {
      fill: 'yellow',
      stroke: 'black',
      strokeWidth: "1.5"
    }
  },
  block: {
    '&:hover $arrow_circle': {
      visibility: 'visible',
    },
    '&:hover $triangle': {
      visibility: 'visible',
    }
  },
  block_arrow_group: {
    '&:hover $arrow_circle': {
      visibility: 'visible',
      fill: 'yellow',
      stroke: 'black',
      strokeWidth: '1.5',
    },
  },
  arrow_circle_active: {
    visibility: 'visible',
    fill: '#4CAF50',
    stroke: '#1B5E20',
    strokeWidth: '1.5',
    '&:hover': {
      fill: 'yellow',
      stroke: 'black',
      strokeWidth: '2',
    },
  },

}));

const useStylesSVG = makeStyles({
  wrapper: {
    width: '100%',
    height: '600px',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    userSelect: 'none',
    WebkitUserSelect: 'none'
  },
  outerWrapper: {
    width: '100%',
    height: '100%',
    overflowX: 'auto',
    // overflowY: 'hidden',
  },
  headerContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: '#f8f9fa',
    flexShrink: 0,
  },
  bodyContainer: {
    flex: 1,
  },
  svg: {
    display: 'block',
  },
});
const sizeDayPerZoom = { 'day': svgProps.sizeDay, 'week': svgProps.sizeWeek / 7, 'month': (svgProps.sizeMonth * 12 / 365) }
export default function GrandView({ fixTable, zoom, percent, formDialog, formDialogDate, formTypeRow, formName, idProject, formView, history }) {
  const dispatch = useDispatch()
  const containerRef = React.useRef(null);
  const classes = useStylesSVG();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (fixTable) {
      container?.removeEventListener("scroll", listenerTable);
      document?.getElementById("sticky-work")?.setAttributeNS(null, "transform", `translate(0,0)`)
    }
    else {
      container?.addEventListener("scroll", listenerTable);
    }
    return () => {
      if (!fixTable) {
        container?.removeEventListener("scroll", listenerTable);
      }
    }
  }, [fixTable])

  useEffect(() => {
    let localStorageHide = []
    try {
      localStorageHide = JSON.parse(localStorage.getItem('gantColumn') || "[]")
    } catch (error) {

    }
    const columnsArrHide = [];
    const columnsHideLocal = { ...COLUMNS_OBJ }
    localStorageHide.forEach(key => { columnsHideLocal[key].hide = true })
    let startDiag = 0;
    COLUMNS_ARR.forEach(key => {
      const obj = COLUMNS_OBJ[key]
      if (!obj) return;
      if (!obj.hide) {
        startDiag += obj.width
      }
      else {
        columnsArrHide.push(key)
      }
    })
    dispatch(actions.formInitialize({
      columnsObj: COLUMNS_OBJ,
      columnsArrHide: columnsArrHide,
      startDiag: startDiag,
      planVisible: true,
    }, { name: formViewProps }))
    return () => {
      dispatch(actions.formDestroy({ name: formViewProps }))
    }
  }, [dispatch])

  const count = useSelector(formSelector(formName, 'count')) || 1
  const length = useSelector(formSelectorLength(formName, 'allIds')) || 0
  const widthSVG = 3*viewBoxWidth + sizeDayPerZoom[zoom] * (count + 10)
  const heightSVG = viewBoxHeight + (length + 1) * svgProps.yPadding
  const heightDateLine = 0
  const headerSvgRef = useRef(null);
  const bodySvgRef = useRef(null);
  const HEADER_HEIGHT = 60;
  const scale = percent / 100
  return (
    <Box className={classes.wrapper} ref={containerRef}>
      <div className={classes.outerWrapper}>
        {/* Шапка */}
        <div className={classes.headerContainer}>
          <svg
            id='svg-header'
            ref={headerSvgRef}
            width={widthSVG * scale}
            height={HEADER_HEIGHT * scale}
            className={classes.svg}
            viewBox={`0 0 ${widthSVG} ${HEADER_HEIGHT}`}
          >
            <rect width="100%" height="100%" fill="#f8f9fa" />
            <TableName />  {/* шапка таблицы с данными */}
            <DateLine
              zoom={zoom}
              sizeDay={svgProps.sizeDay}
              sizeWeek={svgProps.sizeWeek}
              sizeMonth={svgProps.sizeMonth}
              heightDateLine={HEADER_HEIGHT}
            />  {/* шапка с датами */}
          </svg>
        </div>

        {/* Тело */}
        <div className={classes.bodyContainer}>
          <svg
            id='svg-full'
            ref={bodySvgRef}
            width={widthSVG * scale}
            height={heightSVG * scale}
            viewBox={`0 0 ${widthSVG} ${heightSVG}`}
            className={classes.svg}
          >
            <DefsPattern
              heightSVG={heightSVG}
              sizeDay={svgProps.sizeDay}
              sizeWeek={svgProps.sizeWeek}
              yPadding={svgProps.yPadding}
            /> {/*defs шаблоны заливки */}
            <GridTable heightSVG={heightSVG} heightDateLine={heightDateLine} /> {/* поперечные строки таблицы */}
            <GridGantt
              heightSVG={heightSVG}
              zoom={zoom}
              sizeDay={svgProps.sizeDay}
              sizeWeek={svgProps.sizeWeek}
              sizeMonth={svgProps.sizeMonth}
              yPadding={svgProps.yPadding}
              heightDateLine={heightDateLine}
            /> {/* сетка для гантта*/}
            <g>
              <g id='ds'>
                <ClipPathName /> {/* скрываем выход за колонку наименования */}
                <Arrows
                  formName={formName}
                  zoom={zoom}
                /> {/* стрелки */}
                <BlocViewPlan
                  formName={formName}
                  formDialog={formDialog}
                  formView={formView}
                  zoom={zoom}
                /> {/* прямоугольники на сетке план */}
                <BlocView
                  formName={formName}
                  formDialog={formDialog}
                  formDialogDate={formDialogDate}
                  formView={formView}
                  zoom={zoom}
                  idProject={idProject}
                  history={history}
                /> {/* прямоугольники на сетке  */}
                <PropsView formView={formView} heightRec={svgProps.heightRec} /> {/* всплывающее окно при наведении  */}
                <TableData
                  formName={formName}
                  formDialog={formDialog}
                  yPadding={svgProps.yPadding}
                />{/* таблица с данными  */}
              </g>
            </g>
          </svg>
        </div>
      </div>
    </Box>
  );
}

// Отсекает область наименование ---------------------
function ClipPathName() {
  const length = useSelector(state => state.form?.[formName]?.values.allIds.length) || 0
  const columnsObj = useSelector(state => state.form[formViewProps]?.values.columnsObj) || {}
  const columnsArrHide = useSelector(state => state.form[formViewProps]?.values.columnsArrHide) || []
  if (!columnsObj.name || columnsArrHide.includes('name')) return null;
  const arrFilter = COLUMNS_ARR.filter(e => !columnsArrHide.includes(e))
  if (arrFilter.length === 0) return null
  let width = 0
  let i = 0
  let condition = arrFilter[i]
  while (condition !== 'name' && i < arrFilter.length) {
    width += columnsObj[condition].width
    i += 1;
    condition = arrFilter[i]
  };
  return <clipPath id="nameChip">
    <rect x={width} y={- 15} width={columnsObj.name.width} height={svgProps.yPadding * length} />
  </clipPath>
}

function treeToFlatAndFilter(tree, arrFilter) {
  const sorted = [];
  const func = (partTree, pos) => {
    partTree.forEach(path => {
      const { children, ...other } = path
      sorted.push({ ...other, pos: pos + (path.pos || '') });
      if (children.length > 0 && !arrFilter.includes(other.id)) {
        func(children, pos + (other.pos || '') + '.');
      }
    });
  };
  func(tree, '');
  return sorted;
}
//  прямоугольники на сетке план
function BlocViewPlan({ formName, formDialog, zoom, formView }) {
  const classes = useStyles()
  const startRaw = useSelector(formDateSelector(formName, 'start')) || todayString();
  const start = React.useMemo(() => moment(startRaw), [startRaw]);
  const arrFilter = useSelector(formSelector(formName, 'arrFilter'))
  const arrTypeFilter = useSelector(formSelector(formName, 'arrTypeFilter')) || []
  const planVisible = useSelector(formSelector(formViewProps, 'planVisible'))
  const startDiag = useSelector(formSelector(formViewProps, 'startDiag')) || 1810
  const tree = useSelector(state => state.gant)
  const allIdsFiltered = treeToFlatAndFilter(tree.tree, arrFilter).map(e => 'id' + e.id).filter(key => !arrTypeFilter.includes(key))
  if (!planVisible) return null
  return <g>
    {allIdsFiltered.map((key, i) => {
      return <g key={key} transform={`translate(0,${svgProps.yPadding * i})`} className={classes.unselectable}>
        <ViewBlockPlanNew
          start={start}
          startDiag={startDiag}
          zoom={zoom}
          formView={formView}
          height={svgProps.yPadding * i}
          id={key}
          formDialog={formDialog}
        />
      </g>
    })}
  </g>
}
//  прямоугольники план
function ViewBlockPlanNew({ id, startDiag, zoom, start, formView, height, formDialog }) {
  const rawObj = useSelector(state => state.form?.[formName]?.values.byId[id])
  const obj = enrichTaskWithMoments(rawObj);
  const classes = useStylesViewBlock()
  const dispatch = useDispatch()
  const planValid = obj.startPlan?.isValid() && obj.endPlan?.isValid()
  const coordsAll = useMemo(() => {
    if (!planValid) return {
      'day': { startRect: 0, widthRect: 0 },
      'week': { startRect: 0, widthRect: 0 },
      'month': { startRect: 0, widthRect: 0 }
    };
    return {
      'day': {
        startRect: svgProps.sizeDay * (obj.startPlan.diff(start, 'days')),
        widthRect: svgProps.sizeDay * (obj.endPlan.diff(obj.startPlan, 'days') + 1)
      },
      'week': {
        startRect: svgProps.sizeWeek * obj.startPlan.diff(start, 'weeks', true),
        widthRect: svgProps.sizeWeek * moment(obj.endPlan).add(1, 'd').diff(obj.startPlan, 'weeks', true)
      },
      'month': {
        startRect: (svgProps.sizeMonth * 12 / 365) * (obj.startPlan.diff(start, 'days', true)),
        widthRect: (svgProps.sizeMonth * 12 / 365) * (obj.endPlan.diff(obj.startPlan, 'days', true) + 1)
      }
    }
  }, [planValid, obj.startPlan, obj.endPlan, start])
  const handleDoubleClick = () => {
    dispatch(actions.formChangeAsObj({ obj, id, open: true, newRow: false }, { name: formDialog }))
  }
  const handleMouseOver = (e) => {
    dispatch(actions.formChangeAsObj({ obj, open: true, x: e.clientX, y: e.clientY, height }, { name: formView }))
  }
  const handleMoueOut = (e) => {
    dispatch(actions.formChangeAsObj({ obj: null, open: false }, { name: formView }))
  }
  if (obj.typeGant === 'milestone') return null;
  if (!planValid) return null
  const heightPar = Math.round(svgProps.heightRec / 2)
  const coords = coordsAll[zoom] || { startRect: 0, widthRect: 0, }
  return <g
    transform={`translate(${startDiag + coords.startRect},10)`}
    className={classes.block}
    onDoubleClick={handleDoubleClick}
    onMouseOver={handleMouseOver}
    onMouseOut={handleMoueOut}
  >
    {obj.typeGant !== 'parent'
      ? <rect
        id={obj.id + '_rect_main_plan'}
        x={0}
        y={svgProps.heightRec / 1.4}
        width={coords.widthRect}
        height={svgProps.heightRec / 3}
        fill={'#808080'}
      />
      : <path
        id={id + '_path_main_plan_parent'}
        d={`
            M0,0 
            H${coords.widthRect} 
            V${svgProps.heightRec} 
            L${coords.widthRect - heightPar},${heightPar} 
            L${heightPar},${heightPar} 
            L0,${svgProps.heightRec} Z`
        }
        fill={'#8c8c8c'}
        fillOpacity={0.2}
        strokeWidth={1}
      />
    }
  </g>
}
// прямоугольники на сетке -------------------------------------------
export const selectAllIdsFiltered = createSelector(
  [
    (state) => state.gant.flat,
    (state, formName) => state.form?.[formName]?.values.arrFilter,
    (state, formName) => state.form?.[formName]?.values.arrTypeFilter,
  ],
  (flat, filter, typeFilter) => {
    if (!flat) return [];

    const filterSet = new Set(filter || []);
    const typeFilterSet = new Set(typeFilter || []);
    const result = [];

    for (let i = 0; i < flat.length; i++) {
      const row = flat[i];
      if (!filterSet.has(row.parent)) {
        const key = 'id' + row.id;
        if (!typeFilterSet.has(key)) {
          result.push(key);
        }
      }
    }
    return result;
  }
);
const useStyles = makeStyles(theme => ({
  unselectable: {
    '-webkit-touch-callout': 'none',
    '-webkit-user-select': 'none',
    '-khtml-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none'
  },
}));
function BlocView({ formName, formDialog, formDialogDate, zoom, formView, idProject, history }) {
  const classes = useStyles()
  const startRaw = useSelector(formDateSelector(formName, 'start')) || todayString();
  const start = React.useMemo(() => moment(startRaw), [startRaw]);
  const endRaw = useSelector(formDateSelector(formName, 'end')) || todayString();
  const end = React.useMemo(() => moment(endRaw), [endRaw]);

  const startDiag = useSelector(formSelector(formViewProps, 'startDiag')) || 1810

  const tree = useSelector(state => state.gant)
  const allIds = tree.flat.map(e => 'id' + e.id)

  const allIdsFiltered = useSelector(state => selectAllIdsFiltered(state, formName));
  const [selectMove, setSelectMove] = useState(null)
  const [posX, setPosX] = useState(0)
  const [moveId, setMoveId] = useState('')
  const [moveIdAPI, setMoveIdAPI] = useState('')
  const [nowProgress, setNowProgress] = useState(0)
  const [oldProgress, setOldProgress] = useState(0)
  const [maxProgress, setMaxProgress] = useState(0)
  const [typeMove, setTypeMove] = useState('')
  const [otherTarget, setOtherTarget] = useState([])
  const [textStart, setTextStart] = useState(moment())
  const [textEnd, setTextEnd] = useState(moment())
  const [startPoint, setStartPoint] = useState(null)
  const dispatch = useDispatch()
  const classesArrow = useStylesViewBlock()

  const handleDragStart = (e) => {
    // console.log(e.target)
    if (e.target.getAttributeNS(null, 'draggable')) {
      dispatch(actions.formChangeAsObj({ drag: true }, { name: formView }))
      setSelectMove(e.target)
      setPosX(e.clientX)
      setMoveIdAPI(e.target.getAttributeNS(null, 'idapi'))
      setMoveId(e.target.getAttributeNS(null, 'idrow'))
      const typeMove = e.target.getAttributeNS(null, 'typemove')
      setTypeMove(typeMove)
      switch (typeMove) {
        case moveTypes.progress:
          setNowProgress(Number(e.target.getAttributeNS(null, 'nowprogress')))
          setOldProgress(Number(e.target.getAttributeNS(null, 'nowprogress')))
          setMaxProgress(Number(e.target.getAttributeNS(null, 'maxprogress')))
          break;
        case moveTypes.date:
          const id = e.target.getAttributeNS(null, 'id')
          const otherT = [document.getElementById(id + '_main'), document.getElementById(id + '_progress')]
          const idRow = e.target.getAttributeNS(null, 'idrow')
          const s = ['_rect_end', '_rect_start', '_rect_progress_move']
          s.forEach(str => {
            document.getElementById(idRow + str)?.setAttributeNS(null, 'visibility', 'hidden');
          });
          ['_circle_start', '_circle_end', '_rect_progress_move'].forEach(str => {
            document.getElementById(moveId + str)?.setAttributeNS(null, 'fill-opacity', 0);
          });
          setOtherTarget(otherT)
          setNowProgress(0)
          const changeEl = document.getElementById(idRow + '_rect')
          changeEl.setAttributeNS(null, 'y', -3000)
          changeEl.setAttributeNS(null, 'height', 5000)
          changeEl.setAttributeNS(null, 'style', 'fill-opacity: 0.1;cursor: grabbing; stroke-width:0.2; stroke: red; fill:#ff0000')
          break;
        case moveTypes.dateParent: {
          const id = e.target.getAttributeNS(null, 'id')
          const otherT = [document.getElementById(id + '_main')]
          setOtherTarget(otherT)
          setNowProgress(0)
          break;
        }
        case moveTypes.dateMilestone: {
          // const id = e.target.getAttributeNS(null, 'id')
          setOtherTarget([])
          setNowProgress(0)
          break;
        }
        case moveTypes.startDate: {
          setNowProgress(Number(e.target.getAttributeNS(null, 'x')))
          setOldProgress(Number(e.target.getAttributeNS(null, 'x')))
          e.target.setAttributeNS(null, 'fill-opacity', 1)
          const id = e.target.getAttributeNS(null, 'idrow')
          const textRef = document.getElementById(id + '_text_start')
          textRef.setAttributeNS(null, 'visibility', 'visible')
          setTextStart(moment(textRef.textContent, 'DD.MM.YYYY'))
          setOtherTarget([textRef])
          break;
        }
        case moveTypes.endDate: {
          setNowProgress(Number(e.target.getAttributeNS(null, 'x')))
          setOldProgress(Number(e.target.getAttributeNS(null, 'x')))
          e.target.setAttributeNS(null, 'fill-opacity', 1)
          const id = e.target.getAttributeNS(null, 'idrow')
          const textRef = document.getElementById(id + '_text_end')
          textRef.setAttributeNS(null, 'visibility', 'visible')
          setTextEnd(moment(textRef.textContent, 'DD.MM.YYYY'))
          setOtherTarget([textRef])
          break;
        }
        case moveTypes.arrowEnd:
        case moveTypes.arrowStart: {
          const coord = getMousePosition(e);
          setStartPoint(coord)
          const textRef = document.getElementById('arrow-add-all')
          const id = e.target.getAttributeNS(null, 'idrow')
          textRef?.setAttributeNS(null, "d", `M ${coord.x} ${coord.y} L ${coord.x} ${coord.y}`)
          textRef?.setAttributeNS(null, 'visibility', 'visible')
          const arrowCircle = document.getElementById(id + (typeMove === moveTypes.arrowStart ? '_circle_start' : '_circle_end'))
          arrowCircle?.classList.add(classesArrow.arrow_circle_active);
          arrowCircle?.classList.remove(classesArrow.arrow_circle);

          setOtherTarget([textRef])
          break;
        }
        default:
          break;
      }

    }
  }
  const diffDayDrop = (nowProgress, oldProgress = 0) => {
    switch (zoom) {
      case 'day': return Math.ceil((nowProgress - oldProgress) / svgProps.sizeDay);
      case 'week': return Math.ceil((nowProgress - oldProgress) / svgProps.sizeWeek * 7);
      case 'month': return Math.ceil((nowProgress - oldProgress) / svgProps.sizeMonth * 30);
      default: return Math.ceil((nowProgress - oldProgress) / svgProps.sizeDay);
    }
  }
  const handleDrag = (e) => {
    if (!selectMove) return;
    switch (typeMove) {
      case moveTypes.progress: { // deprecated
        let moveLength = nowProgress + e.clientX - posX
        if (moveLength < 0) return;
        if (moveLength === maxProgress) return;
        if (moveLength > maxProgress) moveLength = maxProgress
        selectMove.setAttributeNS(null, "transform", `translate(${moveLength})`);
        setNowProgress(moveLength)
        break;
      }
      case moveTypes.date:
      case moveTypes.dateMilestone:
      case moveTypes.dateParent: {
        let moveLength = nowProgress + e.clientX - posX
        selectMove.setAttributeNS(null, "transform", `translate(${moveLength})`);
        otherTarget.forEach(e => {
          e.setAttributeNS(null, "transform", `translate(${moveLength})`)
        })
        setNowProgress(moveLength)
        break;
      }
      case moveTypes.endDate: {
        let moveLength = nowProgress + e.clientX - posX
        if (zoom === 'day' && moveLength < svgProps.sizeDay - 10) {
          moveLength = svgProps.sizeDay - 10
        }
        if (zoom === 'week' && moveLength < svgProps.month / 7) {
          moveLength = svgProps.month / 7
        }
        if (zoom === 'month' && moveLength < svgProps.sizeMonth / 30) {
          moveLength = svgProps.sizeMonth / 30
        }
        setNowProgress(moveLength)
        selectMove.setAttributeNS(null, 'x', moveLength)
        if (otherTarget[0]) {
          const e = otherTarget[0]
          e.setAttributeNS(null, "transform", `translate(${moveLength - oldProgress})`)
          const diffDay = diffDayDrop(moveLength, oldProgress)
          if (diffDay === 0) break;
          e.textContent = textEnd.clone().add(diffDay, 'd').format('DD.MM.YYYY')
        }
        break;
      }
      case moveTypes.startDate: {
        let moveLength = nowProgress + e.clientX - posX
        setNowProgress(moveLength)
        selectMove.setAttributeNS(null, 'x', moveLength)
        if (otherTarget[0]) {
          const ref = otherTarget[0]
          ref.setAttributeNS(null, "transform", `translate(${moveLength - oldProgress})`)
          const diffDay = diffDayDrop(moveLength, oldProgress)
          if (diffDay === 0) break;
          ref.textContent = textStart.clone().add(diffDay, 'd').format('DD.MM.YYYY')
        }
        break;
      }
      case moveTypes.arrowEnd:
      case moveTypes.arrowStart: {
        if (!startPoint) break;
        if (otherTarget[0]) {
          const ref = otherTarget[0]
          const coord = getMousePosition(e);
          ref.setAttributeNS(null, "d", `M ${startPoint.x} ${startPoint.y} L ${coord.x} ${coord.y}`)
        }
        break;
      }
      default:
        break;
    }
    setPosX(e.clientX)
  }
  const moveActionMulti = (arr) => actions.formObjChangeObjMulti(arr, { field: 'byId', name: formName })
  const moveAction = (id, start, end) => actions.formObjChangeObj({ start, end, }, { field: 'byId', id, name: formName })
  const moveTypeNotParent = (diffDay) => (dispatchInl, getState) => {
    const state = getState()
    const byId = state.form?.[formName]?.values.byId
    const obj = byId[moveId]
    const gant = state.gant
    const newStart = addDays(obj.start, diffDay)
    const newEnd = addDays(obj.end, diffDay)
    dispatchInl(moveAction(moveId, newStart, newEnd));
    const d = getAllMoveChild(obj.idAPI, diffDay, gant, byId, (arr) => dispatchInl(moveActionMulti(arr)));
    return { arrBody: d, body: { start: newStart, end: newEnd } }
  }
  const handleDraEnd = (e) => {
    if (!selectMove) return;
    dispatch(actions.formChangeAsObj({ drag: false }, { name: formView }))
    let body = {}
    let arrBody = []
    switch (typeMove) {
      case moveTypes.progress:
        const newProgress = Math.round(100 * nowProgress / maxProgress)
        dispatch(actions.formObjChangeObj({ progress: newProgress }, { field: 'byId', id: moveId, name: formName }))
        body.progress = newProgress
        break;
      case moveTypes.dateMilestone: {
        const diffDay = diffDayDrop(nowProgress)
        selectMove.setAttributeNS(null, "transform", `translate(${0})`);
        if (diffDay === 0) { break; }
        const resMove = dispatch(moveTypeNotParent(diffDay))
        arrBody.push(...resMove.arrBody)
        body.start = resMove.body.start
        body.end = resMove.body.end
        break;
      }
      case moveTypes.date: {
        const diffDay = diffDayDrop(nowProgress)
        const changeEl = document.getElementById(moveId + '_rect')
        changeEl.setAttributeNS(null, 'y', -10)
        changeEl.setAttributeNS(null, 'height', svgProps.heightRec + 10)
        changeEl.setAttributeNS(null, 'style', 'fill-opacity: 0.0; cursor: grabbing')
        selectMove.setAttributeNS(null, 'fill-opacity', 0.1)
        selectMove.setAttributeNS(null, "transform", `translate(${0})`);
        otherTarget.forEach(e => { e.setAttributeNS(null, "transform", `translate(${0})`) })
        const s = ['_rect_end', '_rect_start']
        s.forEach(str => {
          document.getElementById(moveId + str).setAttributeNS(null, 'visibility', 'visible')
        });
        ['_circle_start', '_circle_end', '_rect_progress_move'].forEach(str => {
          document.getElementById(moveId + str)?.setAttributeNS(null, 'fill-opacity', 1)
        });
        setOtherTarget([])
        if (diffDay === 0) {
          break;
        }

        const resMove = dispatch(moveTypeNotParent(diffDay))
        arrBody.push(...resMove.arrBody)
        body.start = resMove.body.start
        body.end = resMove.body.end
        break;
      }
      case moveTypes.dateParent: {
        const diffDay = diffDayDrop(nowProgress)
        if (diffDay === 0) {
          selectMove.setAttributeNS(null, 'fill-opacity', 0.1)
          selectMove.setAttributeNS(null, "transform", `translate(${0})`);
          break;
        }
        selectMove.setAttributeNS(null, 'fill-opacity', 0.1)
        selectMove.setAttributeNS(null, "transform", `translate(${0})`);
        otherTarget.forEach(e => { e.setAttributeNS(null, "transform", `translate(${0})`) })
        const resMove = dispatch((dispatchInl, getState) => {
          const state = getState()
          const byId = state.form?.[formName]?.values.byId
          const obj = byId[moveId]
          const gant = state.gant
          const newStart = addDays(obj.start, diffDay)
          const newEnd = addDays(obj.end, diffDay)
          const moveArr = []
          const moveParent = []
          const getAllChild = (arr) => {
            for (let i = 0; i < arr.length; i++) {
              const id = arr[i]
              const objChild = byId[id]
              if (objChild.typeGant === 'parent') {
                const newStart = addDays(objChild.start, diffDay)
                const newEnd = addDays(objChild.end, diffDay)
                moveParent.push({ id: id, data: { start: newStart, end: newEnd, } })
                if (objChild.child && objChild.child.length > 0) { getAllChild(objChild.child) }
                else {
                  arrBody.push({ idAPI: objChild.idAPI, body: { start: newStart, end: newEnd } })
                }
              }
              else {
                moveArr.push(objChild.idAPI)
              }
            }
          }
          getAllChild(obj.child)
          dispatchInl(moveActionMulti(moveParent))
          dispatchInl(moveAction(moveId, newStart, newEnd));
          const d = getAllMoveChildParent(moveArr, diffDay, gant, byId, (arr) => dispatchInl(moveActionMulti(arr)));
          dispatch(actions.formObjChangeObj({ start: newStart, end: newEnd }, { field: 'byId', id: moveId, name: formName }))
          getAllParentMove([{ idAPI: Number(obj.idAPI), body: { start: newStart, end: newEnd } }], gant, byId, (arr) => dispatchInl(moveActionMulti(arr)))
          return { arrBody: d, body: { start: newStart, end: newEnd } }
        })
        arrBody.push(...resMove.arrBody)
        setOtherTarget([]);
        break;
      }
      case moveTypes.endDate: {
        selectMove.setAttributeNS(null, 'fill-opacity', 0.1)
        let diffDay = diffDayDrop(nowProgress, oldProgress)
        otherTarget.forEach(e => {
          e.setAttributeNS(null, 'visibility', 'hidden')
          e.setAttributeNS(null, "transform", `translate(${0})`)
        })
        if (diffDay === 0) {
          selectMove.setAttributeNS(null, 'x', oldProgress)
          break;
        }
        const resMove = dispatch((dispatchInl, getState) => {
          const state = getState()
          const byId = state.form?.[formName]?.values.byId
          const obj = byId[moveId]
          const gant = state.gant
          let newEnd = addDays(obj.end, diffDay)
          let duration = obj.duration + diffDay
          if (newEnd && obj.start && newEnd <= obj.start) {
            diffDay = 1
            duration = 1
            newEnd = obj.start
          }
          dispatchInl(actions.formObjChangeObj({ end: newEnd, duration: duration }, { field: 'byId', id: moveId, name: formName }))
          const d = getAllMoveChild(obj.idAPI, diffDay, gant, byId, (arr) => dispatchInl(moveActionMulti(arr)), ['fs', 'ff']);
          return { arrBody: d, body: { end: newEnd, start: obj.start } }
        })
        body.start = resMove.body.start
        body.end = resMove.body.end
        arrBody.push(...resMove.arrBody)
        break;
      }
      case moveTypes.startDate: {
        let diffDay = diffDayDrop(nowProgress, oldProgress)
        selectMove.setAttributeNS(null, 'x', oldProgress)
        selectMove.setAttributeNS(null, 'fill-opacity', 0.1)
        otherTarget.forEach(e => {
          e.setAttributeNS(null, 'visibility', 'hidden')
          e.setAttributeNS(null, "transform", `translate(${0})`)
        })
        if (diffDay === 0) { break; }
        const resMove = dispatch((dispatchInl, getState) => {
          const state = getState()
          const byId = state.form?.[formName]?.values.byId
          const obj = byId[moveId]
          const gant = state.gant
          let newStart = addDays(obj.start, diffDay)
          let duration = obj.duration + diffDay
          if (newStart && obj.end && newStart >= obj.end) {
            diffDay = 1
            duration = 1
            newStart = obj.end
          }
          dispatchInl(actions.formObjChangeObj({ start: newStart, duration: duration }, { field: 'byId', id: moveId, name: formName }))
          const d = getAllMoveChild(obj.idAPI, diffDay, gant, byId, (arr) => dispatchInl(moveActionMulti(arr)), ['fs', 'ff']);
          return { arrBody: d, body: { start: newStart, end: obj.end } }
        })
        body.start = resMove.body.start
        body.end = resMove.body.end
        arrBody.push(...resMove.arrBody)
        break;

      }
      case moveTypes.arrowEnd:
      case moveTypes.arrowStart: {
        var elem = document.elementFromPoint(e.clientX, e.clientY);
        const textRef = document.getElementById('arrow-add-all')
        textRef?.setAttributeNS(null, 'visibility', 'hidden')
        const dataDroppable = elem?.getAttributeNS(null, 'data-droppable');
        const arrowCircle = document.getElementById(moveId + (typeMove === moveTypes.arrowStart ? '_circle_start' : '_circle_end'))
        arrowCircle?.classList.remove(classesArrow.arrow_circle_active);
        arrowCircle?.classList.add(classesArrow.arrow_circle);
        if (dataDroppable && (dataDroppable === 'arrow-end' || dataDroppable === 'arrow-start')) {
          const idRowEnd = elem?.getAttributeNS(null, 'idrow')
          if (idRowEnd === moveId) break;
          dispatch((dispatchInl, getState) => {
            const state = getState()
            const byId = state.form?.[formName]?.values.byId
            const obj = byId[moveId]
            const objTo = byId[idRowEnd]

            const firstPoint = typeMove === moveTypes.arrowStart ? 's' : 'f'
            const endPoint = dataDroppable === 'arrow-start' ? 's' : 'f'
            const typeArrow = firstPoint + endPoint
            const find = obj.dependencies.findIndex(k => {
              return k.type === typeArrow && k.to === idRowEnd
            })
            if (find > -1) return;
            dispatchInl(fetchDispath({
              param: {
                id: idProject,
                idWork: obj.idAPI
              },
              body: {
                idTo: objTo.idAPI,
                typeArrow: typeArrow,
              },
              request: addArrowWorkToGant,
            })).then(res => {
              dispatchInl(actions.formObjChange([...obj.dependencies, {
                id: res.id,
                to: idRowEnd,
                toIndex: allIds.findIndex(w => w === idRowEnd),
                type: typeArrow
              }], {
                name: formName,
                field: 'byId',
                fieldObj: 'dependencies',
                id: moveId
              }))
              dispatchInl(addGantArrow({
                fromId: obj.idAPI,
                id: res.id,
                to: objTo.idAPI,
                type: typeArrow
              }))
            }).catch(err => console.log(err))
          })
        }
        break;
      }
      default:
        break;
    }
    if (Object.keys(body).length > 0) {
      dispatch(fetchDispath({
        param: {
          id: moveIdAPI
        },
        body: body,
        request: updWorkGant(idProject),
      })).then(res => {

      }).catch(err => { console.log(err) })
    }
    arrBody.forEach(e => {
      dispatch(fetchDispath({
        param: {
          id: e.idAPI
        },
        body: e.body,
        request: updWorkGant(idProject),
      })).then(res => { }).catch(err => { console.log(err) })
    })
    if (body.start) {
      const arrMoment = [body.start, ...arrBody.map(e => e.body?.start)]
      const minMaxDate = getMinMaxDates(arrMoment)
      const sizeAdd = zoom === 'day' ? 7 : zoom === 'week' ? 14 : 30
      const newStart = addDays(minMaxDate.min, -sizeAdd)
      const date = {
        start: newStart < startRaw ? newStart : startRaw,
      }
      dispatch(actions.formChangeAsObj({ start: date.start, count: diffDays(date.start, endRaw), }, { name: formName }))
      dispatch((dispatchInl, getState) => {
        const state = getState()
        const byId = state.form?.[formName]?.values.byId
        const gant = state.gant
        getAllParentMove([...arrBody, { idAPI: Number(moveIdAPI), body: body }], gant, byId, (arr) => dispatchInl(moveActionMulti(arr)))
      })
    }
    if (body.end) {
      const arrMoment = [body.end, ...arrBody.map(e => e.body?.end)]
      const minMaxDate = getMinMaxDates(arrMoment)
      const sizeAdd = zoom === 'day' ? 7 : zoom === 'week' ? 14 : 30
      const newEnd = addDays(minMaxDate.max, sizeAdd)
      const date = {
        end: newEnd > endRaw ? newEnd : endRaw,
      }
      dispatch(actions.formChangeAsObj({ end: date.end, count: diffDays(startRaw, date.end) }, { name: formName }))
      dispatch((dispatchInl, getState) => {
        const state = getState()
        const byId = state.form?.[formName]?.values.byId
        const gant = state.gant
        getAllParentMove([...arrBody, { idAPI: Number(moveIdAPI), body: body }], gant, byId, (arr) => dispatchInl(moveActionMulti(arr)))
      })
    }
    setSelectMove(null)
    setNowProgress('')
    setOldProgress('')
    setMaxProgress('')
  }
  const size = zoom === 'day' ? svgProps.sizeDay : zoom === 'week' ? svgProps.sizeWeek : svgProps.sizeMonth
  return (
    <g
      id='svg-drag'
      onMouseDown={handleDragStart}
      onMouseMove={handleDrag}
      onMouseUp={handleDraEnd}
      onMouseLeave={handleDraEnd}
    >
      {selectMove && <rect x={startDiag} y="1" width={(end.diff(start, zoom) + 5) * size} height={allIds.length * svgProps.yPadding} fillOpacity="0" />}
      {allIdsFiltered.map((key, i) => {
        const isCrit = tree.crit.path.includes(key)
        return (
          <g key={key} transform={`translate(0,${svgProps.yPadding * i})`} className={classes.unselectable}>
            <ViewBlock
              startDiag={startDiag}
              zoom={zoom}
              startRaw={startRaw}
              formView={formView}
              height={svgProps.yPadding * i}
              id={key}
              formDialog={formDialog}
              formDialogDate={formDialogDate}
              history={history}
              isCrit={isCrit}
            />
          </g>
        )
      })}
      <defs>
        <marker
          id="arrow-head"
          viewBox="0 0 10 10"
          refX="6"
          refY="5"
          markerWidth="6"
          markerHeight="6"
          orient="auto-start-reverse"
        >
          <path d="M 0 1 L 10 5 L 0 9 z" fill="orange" />
        </marker>
      </defs>
      <path
        id='arrow-add-all'
        startpoint='m 0 0' d='m 0 0'
        stroke="orange"
        strokeWidth={3}
        strokeDasharray="10,10"
        fill="none"
        style={{ pointerEvents: 'none' }}
        markerEnd="url(#arrow-head)"
      />
    </g>
  )
}
function getMousePosition(evt) {
  const svg = document.getElementById('svg-full')
  var pt = svg.createSVGPoint();
  pt.x = evt.clientX//evt.pageX;
  pt.y = evt.clientY//evt.pageY;
  const p = pt.matrixTransform(svg.getScreenCTM().inverse());
  return p
}
function getAllParentMove(arr, gant, byId, moveDispatch) {
  const change = []
  function findFunc(arrFind) {
    const parents = {}
    const newArr = []
    arrFind.forEach(e => {
      const obj = gant.flat.find(f => f.id === e.idAPI)
      if (obj && obj.parent > 0) {
        if (parents[obj.parent]) {
          parents[obj.parent].child.push({ id: e.idAPI, start: e.body.start, end: e.body.end })
        }
        else {
          parents[obj.parent] = {
            child: [{ id: e.idAPI, start: e.body.start, end: e.body.end }],
            start: byId['id' + obj.parent].start,
            end: byId['id' + obj.parent].end,
            idAPI: obj.parent,
            level: obj.level - 1
          }
        }
      }
    })
    Object.values(parents).sort((a, b) => b.level - a.level).forEach(obj => {
      let changed = false
      let resultStart = obj.start
      let resultEnd = obj.end
      const child = [...obj.child.map(e => ({ start: e.start, end: e.end }))]
      const childArr = obj.child.map(e => e.id)
      gant.flat.filter(e => e.parent === obj.idAPI && !childArr.includes(e.id)).forEach(fl => {
        const findCh = change.find(e => e.idAPI === fl.id)
        if (findCh) {
          child.push({
            start: findCh.body.start,
            end: findCh.body.end
          })
        }
        else {
          child.push({
            start: byId['id' + fl.id].start,
            end: byId['id' + fl.id].end
          })
        }
      })
      const newRange = getGanttDateRange(child)
      if (obj.end !== newRange.max) {
        resultEnd = newRange.max
        changed = true
      }
      if (obj.start !== newRange.min) {
        resultStart = newRange.min
        changed = true
      }
      if (changed) {
        change.push({ idAPI: obj.idAPI, body: { start: resultStart, end: resultEnd } })
        const objF = gant.flat.find(f => f.id === obj.idAPI)
        if (!parents[objF.parent]) {
          newArr.push({ idAPI: obj.idAPI, body: { start: resultStart, end: resultEnd } })
        }
      }
    })
    if (newArr.length > 0) {
      findFunc(newArr)
    }
  }
  findFunc(arr)
  const changeArr = []
  change.forEach(obj => {
    changeArr.push({ id: 'id' + obj.idAPI, data: { start: obj.body.start, end: obj.body.end } })
  })
  moveDispatch(changeArr)
}
function getAllMoveChildParent(arr, diffDay, gant, byId, moveDispatchMulti) {
  const { adjList } = gant
  if (arr.length === 0) return []
  const arrRes = []
  const visited = []
  const notVisited = arr
  while (notVisited.length > 0) {
    const find = notVisited.pop()
    if (!visited.includes(find)) {
      visited.push(find)
      if (adjList[find]) {
        notVisited.push(...adjList[find].map(e => e.to))
      }
    }
  }
  const moveArr = []
  visited.forEach(id => {
    const objChild = byId['id' + id]
    const newStart = addDays(objChild.start, diffDay)
    const newEnd = addDays(objChild.end, diffDay)
    arrRes.push({ idAPI: id, body: { start: newStart, end: newEnd } })
    moveArr.push({ id: 'id' + id, data: { start: newStart, end: newEnd } })
  })
  moveDispatchMulti(moveArr)
  return arrRes
}
function getAllMoveChild(id, diffDay, gant, byId, moveDispatchMulti, moveType = ['fs', 'ss', 'ff', 'sf']) {
  const { adjList } = gant
  if (!adjList[id]) return []
  const arrRes = []
  const visited = []
  const notVisited = adjList[id].filter(e => moveType.includes(e.type)).map(e => e.to)
  while (notVisited.length > 0) {
    const find = notVisited.pop()
    if (!visited.includes(find)) {
      visited.push(find)
      if (adjList[find]) {
        notVisited.push(...adjList[find].map(e => e.to))
      }
    }
  }
  const moveArr = []
  visited.forEach(id => {
    const objChild = byId['id' + id]
    if (objChild.typeGant === 'link') return;
    const newStart = addDays(objChild.start, diffDay)
    const newEnd = addDays(objChild.end, diffDay)
    arrRes.push({ idAPI: id, body: { start: newStart, end: newEnd } })
    moveArr.push({ id: 'id' + id, data: { start: newStart, end: newEnd } })
  })
  moveDispatchMulti(moveArr)
  return arrRes
}
//  прямоугольники факт
const ViewBlock = memo(function ViewBlock({ startDiag, startRaw, zoom, formView, formDialogDate, height, id, formDialog, history, isCrit }) {
  const rawObj = useSelector(state => state.form?.[formName]?.values.byId[id])
  const obj = enrichTaskWithMoments(rawObj);
  const coordsAll = useMemo(() => {
    const start = moment(startRaw);
    return {
      'day': {
        size: svgProps.sizeDay,
        startRect: obj.start.diff(start, 'days'),
        widthRect: obj.end.diff(obj.start, 'days') + 1
      },
      'week': {
        size: svgProps.sizeWeek,
        startRect: obj.start.diff(start, 'weeks', true),
        widthRect: moment(obj.end).add(1, 'd').diff(obj.start, 'weeks', true)
      },
      'month': {
        size: svgProps.sizeMonth * 12 / 365,
        startRect: obj.start.diff(start, 'days', true),
        widthRect: obj.end.diff(obj.start, 'days', true) + 1
      }
    }
  }, [obj.start, obj.end, startRaw])
  const coords = coordsAll[zoom] || {
    'day': { size: svgProps.sizeDay, startRect: 0, widthRect: 0 },
    'week': { size: svgProps.sizeWeek, startRect: 0, widthRect: 0 },
    'month': { size: svgProps.sizeDay, startRect: 0, widthRect: 0 }
  }
  const dispatch = useDispatch()
  const handleMouseOver = (e) => {
    dispatch(actions.formChangeAsObj({ obj, open: true, x: e.clientX, y: e.clientY, height }, { name: formView }))
  }
  const handleMoueOut = (e) => {
    dispatch(actions.formChangeAsObj({ obj: null, open: false }, { name: formView }))
  }
  const handleChangeRow = () => {
    if (obj.typeGant === 'parent') {
      dispatch(actions.formChangeAsObj({ obj, id, open: true }, { name: formDialogDate }))
    }
    else if (obj.typeGant !== 'link') {
      dispatch(actions.formChangeAsObj({ obj, id, open: true, newRow: false }, { name: formDialog }))
    }
    else {
      history.push(`/projects/${obj.idProjectLink}/form/gant`)
    }
  }
  switch (obj.typeGant) {
    case 'parent':
      return <ViewBlockParent
        id={obj.id}
        idAPI={obj.idAPI}
        startDiag={startDiag}
        startRect={coords.startRect}
        size={coords.size}
        handleMouseOver={handleMouseOver}
        handleMoueOut={handleMoueOut}
        handleChangeRow={handleChangeRow}
        widthRect={coords.widthRect}
      />
    case 'milestone':
      return <ViewBlockMilestone
        id={obj.id}
        idAPI={obj.idAPI}
        startDiag={startDiag}
        startRect={coords.startRect}
        size={coords.size}
        handleMouseOver={handleMouseOver}
        handleMoueOut={handleMoueOut}
        handleChangeRow={handleChangeRow}
        widthRect={coords.widthRect}
        isCrit={isCrit}
      />
    case 'link':
      return <ViewBlockLink
        id={obj.id}
        idAPI={obj.idAPI}
        progress={obj.progress}
        startDiag={startDiag}
        startRect={coords.startRect}
        size={coords.size}
        handleMouseOver={handleMouseOver}
        handleMoueOut={handleMoueOut}
        handleChangeRow={handleChangeRow}
        widthRect={coords.widthRect}
        isCrit={isCrit}
      />
    default:
      return <ViewBlockMain
        obj={obj}
        startDiag={startDiag}
        startRect={coords.startRect}
        size={coords.size}
        handleMouseOver={handleMouseOver}
        handleMoueOut={handleMoueOut}
        handleChangeRow={handleChangeRow}
        widthRect={coords.widthRect}
        isCrit={isCrit}
      />
  }
})

function ViewBlockParent({ id, idAPI, startDiag, startRect, size, handleMouseOver, handleMoueOut, widthRect, handleChangeRow }) {
  const heightPar = Math.round(svgProps.heightRec / 2)
  const type = typeGant.find(e => e.value === 'parent')
  return <g transform={`translate(${startDiag + startRect * size},10)`}
    onMouseOver={handleMouseOver}
    onMouseOut={handleMoueOut}
    onDoubleClick={handleChangeRow}
  >
    <path
      id={id + '_rect_main'}
      x={0} y={0}
      d={`
          M0,0 
          H${size * widthRect} 
          V${svgProps.heightRec} 
          L${size * widthRect - heightPar},${heightPar} 
          L${heightPar},${heightPar} 
          L0,${svgProps.heightRec} Z`
      }
      fill={type.color}
    />
    <rect id={id + '_rect'} x={0} y={0}
      width={size * widthRect}
      height={heightPar}
      draggable
      droppable='true'
      style={{ fillOpacity: '.05', cursor: 'grabbing' }}
      idapi={idAPI}
      idrow={id}
      typemove={moveTypes.dateParent}
      fillOpacity='0.05'
    />
  </g>
}
function ViewBlockMilestone({ id, idAPI, startDiag, startRect, size, handleMouseOver, handleMoueOut, handleChangeRow, widthRect, isCrit }) {
  const classes = useStylesViewBlock()
  const type = { ...typeGant.find(e => e.value === 'milestone') }
  if (isCrit) {
    type.color = '#AA0000'
    type.colorPercent = '#DD0000'
  }
  const halfWidth = svgProps.heightRec / 2;
  const halfHeight = svgProps.heightRec / 2;
  return <g
    transform={`translate(${startDiag + startRect * size},6.125)`}
    className={classes.block}
    onMouseOver={handleMouseOver}
    onMouseOut={handleMoueOut}
    onDoubleClick={handleChangeRow}
  >
    <rect
      x={-halfHeight}
      y={0}
      width={svgProps.heightRec}
      height={svgProps.heightRec}
      fillOpacity='0.0'
    />
    <polygon id={id + '_rect_main'}
      points={`
        0,0, 
        ${halfWidth},${halfHeight}, 
        0,${svgProps.heightRec}, 
        ${-halfWidth},${halfHeight}`}
      fill={type.color}
      stroke={type.color}
      strokeWidth={0}
      draggable
      droppable='true'
      style={{ cursor: 'grabbing' }}
      idapi={idAPI}
      idrow={id}
      typemove={moveTypes.dateMilestone}
      fillOpacity='0.5'
    />
    <g className={classes.block_arrow_group}>
      <circle
        id={id + '_circle_start'}
        typemove={moveTypes.arrowStart}
        draggable cx={-halfWidth - svgProps.heightRec}
        cy={svgProps.heightRec / 2}
        r={svgProps.heightRec / 3}
        className={classes.arrow_circle}
      />
      <rect
        id={id + '_arrow_start'}
        typemove={moveTypes.arrowStart}
        draggable
        x={-halfWidth - svgProps.heightRec - svgProps.heightRec / 3}
        y={0}
        width={svgProps.heightRec + svgProps.heightRec / 3}
        height={svgProps.heightRec}
        data-droppable="arrow-start"
        fillOpacity='0.0'
        idapi={idAPI}
        idrow={id}
      />
    </g>
    <g className={classes.block_arrow_group}>
      <circle
        id={id + '_circle_end'}
        cx={halfWidth + svgProps.heightRec}
        cy={svgProps.heightRec / 2}
        r={svgProps.heightRec / 3}
        className={classes.arrow_circle}
      />
      <rect
        id={id + '_arrow_end'}
        typemove={moveTypes.arrowEnd}
        draggable
        x={halfWidth}
        y={0}
        width={svgProps.heightRec + svgProps.heightRec / 3}
        height={svgProps.heightRec}
        data-droppable="arrow-end"
        fillOpacity='0.0'
        idapi={idAPI}
        idrow={id}
      />
    </g>

  </g>
}
function ViewBlockLink({ id, idAPI, progress, startDiag, startRect, size, handleMouseOver, handleMoueOut, handleChangeRow, widthRect, isCrit }) {
  const classes = useStylesViewBlock()
  const type = { ...typeGant.find(e => e.value === 'link') }
  if (isCrit) {
    type.color = '#AA0000'
    type.colorPercent = '#DD0000'
  }
  return <g
    transform={`translate(${startDiag + startRect * size},10)`}
    className={classes.block}
    onMouseOver={handleMouseOver}
    onMouseOut={handleMoueOut}
    onDoubleClick={handleChangeRow}
  >
    <rect
      x={-svgProps.heightRec}
      y={0}
      width={svgProps.heightRec}
      height={svgProps.heightRec / 1.5}
      fillOpacity='0.0'
    />
    <rect
      x={size * widthRect}
      y={0}
      width={svgProps.heightRec}
      height={svgProps.heightRec / 1.5}
      fillOpacity='0.0'
    />
    <rect id={id + '_rect_main'} x={0} y={0}
      width={size * widthRect}
      height={svgProps.heightRec / 1.5}
      fill={type.color}
      idapi={idAPI}
      idrow={id}
      typemove={moveTypes.date}
      fillOpacity='0.8'
    />
    <rect id={id + '_rect_progress'} x={0} y={0}
      width={size * Math.round(widthRect * progress / 100)}
      height={svgProps.heightRec / 1.5}
      fill={type.colorPercent}
      fillOpacity='1'
    />
    <g className={classes.block_arrow_group}>
      <circle
        id={id + '_circle_start'}
        cx={-svgProps.heightRec}
        cy={svgProps.heightRec / 3}
        r={svgProps.heightRec / 3}
        className={classes.arrow_circle}
      />
      <rect
        id={id + '_arrow_start'}
        typemove={moveTypes.arrowStart}
        draggable
        x={-svgProps.heightRec - svgProps.heightRec / 3}
        y={0}
        width={svgProps.heightRec + svgProps.heightRec / 3}
        height={svgProps.heightRec / 1.5}
        data-droppable="arrow-start"
        fillOpacity='0.0'
        idapi={idAPI}
        idrow={id}
      />
    </g>
    <g className={classes.block_arrow_group}>
      <circle
        id={id + '_circle_end'}
        cx={size * widthRect + svgProps.heightRec}
        cy={svgProps.heightRec / 3}
        r={svgProps.heightRec / 3}
        className={classes.arrow_circle}
      />
      <rect
        id={id + '_arrow_end'}
        typemove={moveTypes.arrowEnd}
        draggable
        x={size * widthRect}
        y={0}
        width={svgProps.heightRec + svgProps.heightRec / 3}
        height={svgProps.heightRec / 1.5}
        data-droppable="arrow-end"
        fillOpacity='0.0'
        idapi={idAPI}
        idrow={id}
      />
    </g>
  </g>
}
function ViewBlockMain({ obj, startDiag, startRect, size, handleMouseOver, handleMoueOut, handleChangeRow, widthRect, isCrit }) {
  const classes = useStylesViewBlock()
  const type = { ...typeGant.find(e => e.value === obj.typeGant) }
  if (isCrit) {
    type.color = '#AA0000'
    type.colorPercent = '#DD0000'
  }
  const widthPol = size * Math.round(widthRect * (obj.progress) / 100)
  return <g
    transform={`translate(${startDiag + startRect * size},10)`}
    className={classes.block}
    onMouseOver={handleMouseOver}
    onMouseOut={handleMoueOut}
    onDoubleClick={handleChangeRow}
  >
    <rect id={obj.id + '_rect_main'} x={0} y={0}
      width={size * widthRect}
      height={svgProps.heightRec / 1.5}
      fill={type.color}
      idapi={obj.idAPI}
      idrow={obj.id}
      typemove={moveTypes.date}
      fillOpacity='0.8'
    />
    <rect id={obj.id + '_rect_progress'} x={0} y={0}
      width={size * Math.round(widthRect * obj.progress / 100)}
      height={svgProps.heightRec / 1.5}
      fill={type.colorPercent}
      fillOpacity='1'
    />
    <rect id={obj.id + '_rect'} x={0} y={-10}
      width={size * widthRect}
      height={svgProps.heightRec + 10}
      draggable
      droppable='true'
      style={{ fillOpacity: '.00', cursor: 'grabbing' }}
      idapi={obj.idAPI}
      idrow={obj.id}
      typemove={moveTypes.date}
      fillOpacity='0.00'
    />
    <text visibility="hidden"
      id={obj.id + '_text_start'}
      x={- 60}
      y={svgProps.heightRec / 1.5}
      dominantBaseline="middle"
      textAnchor="middle" >{obj.start.format('DD.MM.YYYY')}</text>
    <text visibility="hidden"
      id={obj.id + '_text_end'}
      x={size * widthRect + 60}
      y={0}
      dominantBaseline="middle"
      textAnchor="middle">{obj.end.format('DD.MM.YYYY')}</text>
    <rect id={obj.id + '_rect_end'} x={size * widthRect - size / 5} y={0}
      width={size / 5}
      height={svgProps.heightRec / 1.5}
      rx='3' ry='3'
      fill="yellow"
      fillOpacity='0.1'
      draggable
      idapi={obj.idAPI}
      idrow={obj.id}
      typemove={moveTypes.endDate}
      style={{ cursor: 'e-resize' }}
    />
    <rect id={obj.id + '_rect_start'} x={0} y={0}
      width={size / 5}
      height={svgProps.heightRec / 1.5}
      rx='3' ry='3'
      fill="yellow"
      fillOpacity='0.1'
      draggable
      idapi={obj.idAPI}
      idrow={obj.id}
      typemove={moveTypes.startDate}
      style={{ cursor: 'w-resize' }}
    />
    <g className={classes.block_arrow_group}>
      <circle
        id={obj.id + '_circle_start'}
        cx={-svgProps.heightRec}
        cy={svgProps.heightRec / 3}
        r={svgProps.heightRec / 3}
        className={classes.arrow_circle}
      />
      <rect
        id={obj.id + '_arrow_start'}
        typemove={moveTypes.arrowStart}
        draggable
        x={-svgProps.heightRec - svgProps.heightRec / 3}
        y={0}
        width={svgProps.heightRec + svgProps.heightRec / 3}
        height={svgProps.heightRec / 1.5}
        data-droppable="arrow-start"
        fillOpacity='0.0'
        idapi={obj.idAPI}
        idrow={obj.id}
      />
    </g>
    <g className={classes.block_arrow_group}>
      <circle
        id={obj.id + '_circle_end'}
        cx={size * widthRect + svgProps.heightRec}
        cy={svgProps.heightRec / 3}
        r={svgProps.heightRec / 3}
        className={classes.arrow_circle}
      />
      <rect
        id={obj.id + '_arrow_end'}
        typemove={moveTypes.arrowEnd}
        draggable
        x={size * widthRect}
        y={0}
        width={svgProps.heightRec + svgProps.heightRec / 3}
        height={svgProps.heightRec / 1.5}
        data-droppable="arrow-end"
        fillOpacity='0.0'
        idapi={obj.idAPI}
        idrow={obj.id}
      />
    </g>
  </g>
}

// increase column width -------------------------------
function TableName() {
  const columnsObj = useSelector(state => state.form[formViewProps]?.values.columnsObj || {})
  const startDiag = useSelector(state => state.form[formViewProps]?.values.startDiag || 0)
  const columnsArrHide = useSelector(state => state.form[formViewProps]?.values.columnsArrHide || [])
  const dispatch = useDispatch()
  let x = 0
  let xs = 0
  const [selectMove, setSelectMove] = useState(null)
  const [posX, setPosX] = useState(0)
  const [move, setMove] = useState(0)
  const [typeMove, setTypeMove] = useState(null)
  const handleDragStart = (e) => {
    if (e.target.getAttributeNS(null, 'draggable')) {
      const name = e.target.getAttributeNS(null, 'type')
      setSelectMove(e.target)
      setPosX(e.clientX)
      setTypeMove(name)
    }
  }
  const handleDrag = (e) => {
    if (!selectMove) return;
    setMove(move + e.clientX - posX)
    setPosX(e.clientX)
  }
  const handleDraEnd = () => {
    if (!selectMove) return;
    setSelectMove(null)
    const column = columnsObj[typeMove]
    let newWidth = column.width + move
    if (column && column.widthMin >= newWidth) { newWidth = column.widthMin }
    dispatch(actions.formObjChangeObj({
      width: newWidth,
    }, { field: 'columnsObj', id: typeMove, name: formViewProps }))
    dispatch(actions.formChange(startDiag + newWidth - column.width, { field: 'startDiag', name: formViewProps }))
    setMove(0)
    setTypeMove(false)
  }
  return <g>
    {COLUMNS_ARR.filter(e => !columnsArrHide.includes(e)).map(key => {
      const column = columnsObj[key]
      if (!column) return null // ВРЕМЕННО!!!!!!!!!!!!!!!!!!
      const width = column.width
      x += width
      return <OneRect key={key} x={x - width} y={0} width={width} name={column.name} />
    })}
    <g
      onMouseDown={handleDragStart}
      onMouseMove={handleDrag}
      onMouseUp={handleDraEnd}
      onMouseLeave={handleDraEnd}
    >
      <rect x={0} y={0} height={60} width={x} fill='#ffffff' fillOpacity='0.1' />
      {COLUMNS_ARR.filter(e => !columnsArrHide.includes(e)).map(key => {
        const column = columnsObj[key]
        if (!column) return null // ВРЕМЕННО!!!!!!!!!!!!!!!!!!
        const width = column.width
        xs += width
        return <line
          key={key}
          x1={xs + ((typeMove === key) ? move : 0)}
          y1={0}
          x2={xs + ((typeMove === key) ? move : 0)}
          y2={60}
          stroke="#a6a6a6"
          strokeWidth="2"
          draggable
          type={key}
          style={{ cursor: 'ew-resize' }}
        />
      })}
    </g>
  </g>
}
function OneRect({ x, y, width, name }) {
  return <g transform={`translate(${x},${y})`}>
    <rect x={0} y={0} stroke="#a6a6a6" strokeWidth="1" fill="white" width={width} height={60} />
    <text dominantBaseline="middle" textAnchor="middle" x={width / 2} y={30}  >{name}</text>
  </g>
}